import { useMemo } from "react"

const getInitialFormState = (province?: string) => {
  try {
    const storedStateUnparsed = sessionStorage.getItem(`form-state-${province}`)

    if (!storedStateUnparsed) return undefined

    const storedState = JSON.parse(storedStateUnparsed)

    return storedState ?? undefined
  } catch (e) {
    console.error(e)
    return undefined
  }
}

export const useInitialFormStateByProvince = (province: string) => {
  const initialFormState = useMemo(
    () => getInitialFormState(province),
    [province],
  )
  return { initialFormState }
}
